/* AURÉ — global theme JS, ported from the approved one-page site (index.html).
   Provides the two globals every aure-* section relies on:
     window.aureToast(msg)               — the site-wide toast
     window.aureCartAdd(variantId, qty)  — AJAX add-to-cart + live cart count
   Everything is guarded for missing elements and re-initialized on the
   theme editor's shopify:section:load. Vanilla IIFE, zero dependencies. */
(function () {
  'use strict';

  function routesRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* ---------- toast (same visual toast as the approved site) ---------- */
  var toastTimer = null;
  window.aureToast = function (msg) {
    var toast = document.getElementById('toast');
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('is-on'); }, 3400);
  };

  /* ---------- AJAX cart ---------- */
  function updateCartCount(count) {
    var els = document.querySelectorAll('[data-cart-count]');
    Array.prototype.forEach.call(els, function (el) { el.textContent = count; });
  }

  window.aureCartAdd = function (variantId, qty) {
    if (!variantId) { return Promise.reject(new Error('aureCartAdd: missing variant id')); }
    var root = routesRoot();
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) {
            /* /cart/add.js returns 422 {status, message, description} for sold-out etc. */
            window.aureToast(data.description || data.message || 'Something went wrong — please try again.');
            throw data;
          }
          return data;
        });
      })
      .then(function (added) {
        /* add.js only returns the added line items — GET cart.js for the new item_count */
        return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (cart && typeof cart.item_count !== 'undefined') { updateCartCount(cart.item_count); }
            window.aureToast('Added to your ritual.');
            return { added: added, cart: cart };
          });
      });
  };

  /* ---------- scroll reveals (once per element; editor-safe) ---------- */
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function initReveals() {
    var revealed = document.querySelectorAll('.reveal:not(.is-in)');
    if (!revealed.length) return;
    if ('IntersectionObserver' in window && !reduceMotion.matches) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      Array.prototype.forEach.call(revealed, function (el) { io.observe(el); });
    } else {
      Array.prototype.forEach.call(revealed, function (el) { el.classList.add('is-in'); });
    }
  }

  /* ---------- data-toast delegation (kept from the approved site) ---------- */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var el = e.target.closest('[data-toast]');
    if (!el) return;
    if (el.tagName === 'A') e.preventDefault();
    window.aureToast(el.getAttribute('data-toast'));
  });

  /* ---------- section integration point: aure:add-to-ritual ----------
     Sections (the quiz) dispatch a bubbling CustomEvent. If the detail
     carries a variantId the add is real; otherwise no product is wired,
     so guide honestly to The Four instead of faking a confirmation. */
  document.addEventListener('aure:add-to-ritual', function (e) {
    var d = (e && e.detail) || {};
    if (d.variantId) { window.aureCartAdd(d.variantId, d.quantity || 1); return; }
    var names = { halo: 'HALO', clear: 'CLEAR', ease: 'EASE', dusk: 'DUSK', full: 'The Full Ritual' };
    window.aureToast((names[d.sku] || 'Your ritual') + ' — find it in The Four.');
    var shop = document.getElementById('shop');
    if (shop) {
      shop.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }
  });

  /* ---------- The Letter form ----------
     Client-side validation kept from the approved site, but the demo
     behavior is replaced: when the form is a real {% form 'customer' %}
     (action contains '/contact') a valid email submits natively. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.classList || !form.classList.contains('letter-form')) return;

    var input = form.querySelector('.letter-input');
    var msg = form.querySelector('.letter-msg') || document.getElementById('letter-msg');
    if (!input) return;

    var v = (input.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) {
      e.preventDefault();
      if (msg) msg.textContent = 'That email doesn’t look right — mind checking it?';
      input.setAttribute('aria-invalid', 'true');
      input.focus();
      return;
    }
    input.removeAttribute('aria-invalid');

    var action = form.getAttribute('action') || '';
    if (action.indexOf('/contact') !== -1) return; /* real customer form — let it POST natively */

    /* No Shopify action wired (static preview only) — inline confirmation */
    e.preventDefault();
    if (msg) msg.textContent = 'You’re in. First letter next month.';
    input.value = '';
  });

  /* ---------- boot + theme editor re-init ---------- */
  initReveals();
  document.addEventListener('shopify:section:load', function () { initReveals(); });
})();
